module.exports = __webpack_public_path__ + "static/media/check_provider.137dc808.svg";